module.exports = __webpack_public_path__ + "img/about.3840a6a5.png";